import React from "react";

const MilestoneSkeleton = () => {
  return (
    
      <div className="bg-white p-5 rounded-xl shadow">
        {/* Header Skeleton */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-2">
            <div className="h-5 w-5 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-6 w-56 bg-gray-200 rounded animate-pulse"></div>
          </div>
        
        </div>

        {/* Milestone Cards Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="rounded-xl p-4 shadow border bg-white min-h-[230px] animate-pulse"
            >
              <div className="flex justify-between items-center mb-3">
                <div className="h-4 w-16 bg-gray-200 rounded"></div>
                <div className="h-6 w-16 bg-gray-200 rounded-full"></div>
              </div>
              <div className="h-8 w-20 bg-gray-300 rounded mb-2"></div>
              <div className="h-3 w-32 bg-gray-200 rounded mb-2"></div>
              <div className="h-4 w-16 bg-gray-200 rounded mb-2 mt-2"></div>
              <div className="h-3 w-28 bg-gray-200 rounded"></div>
            </div>
          ))}
        </div>
      </div>
   
  );
};

export default MilestoneSkeleton;

